import { dataToSendData } from "@/common/interface_api/check_send.js";
export default function(api){
    api.__createBearerApi(["getLicList", "UMH-获取LIC列表"], "/v2/umh/admin/liccode/list" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["lic_code", "grant_mac"],
            numKey : ["page_no", "page_size"],
        });
        return sendData;
    });
    api.__createBearerApi(["getAppUserList", "UMH-获取角色列表"], "/v2/umh/admin/user/list" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["user_id"],
            numKey : ["page_no", "page_size", "comp_id", "master_id"],
        });
        return sendData;
    });
    api.__createBearerApi_otherServer(["getAppUserList_otherAddr", "UMH-获取角色列表[其他服务器]"], "/v2/umh/admin/user/list" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["user_id"],
            numKey : ["page_no", "page_size", "comp_id", "master_id"],
        });
        return sendData;
    });

    api.__createSimpleApi(["getAppUserProductList", "UMH-获取产品列表"], "/v2/umh/admin/product/list" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["share_sou","uid"],
            numKey : ["page_no", "page_size", ],
        });
        return sendData;
    });
    api.__createBearerApi(["getShareProduct", "UMH-获取分享商品列表"], "/v2/umh/admin/product/share/list" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["user_id","node_id"],
            numKey : ["page_no", "page_size"],
        });
        return sendData;
    });
    api.__createBearerApi(["addShareProduct", "UMH-新增分享商品"], "/v2/umh/admin/product/share/add" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["to_userid","node_id"],
            numKey : [],
        });
        return sendData;
    });
    api.__createBearerApi(["delShareProduct", "UMH-删除分享列表"], "/v2/umh/admin/product/share/delete" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["id"],
            numKey : [],
        });
        return sendData;
    });
    api.__createBearerApi(["delAppUserProduct", "UMH-删除产品"], "/v2/umh/admin/product/delete" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["node_id"],
            numKey : [],
        });
        return sendData;
    });

    api.__createBearerApi(["addMsgCfg", "UMH-添加消息事件配置"], "/v2/umh/admin/msg/eventcfg/add" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["event_name", "lang_flag"],
            numKey : ["alarm_event"],
        });
        return sendData;
    });

    api.__createBearerApi(["editMsgCfg", "UMH-设置消息事件配置"], "/v2/umh/admin/msg/eventcfg/set" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["event_name", "lang_flag"],
            numKey : ["id", "alarm_event"],
        });
        return sendData;
    });
    api.__createBearerApi(["delMsgCfg", "UMH-删除消息事件配置"], "/v2/umh/admin/msg/eventcfg/del" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : [],
            numKey : ["id"],
        });
        return sendData;
    });

    api.__createBearerApi(["getMsgCfg", "UMH-查询消息事件配置"], "/v2/umh/admin/msg/eventcfg/list" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["lang_flag"],
            numKey : ["alarm_event","page_no", "page_size"],
        });
        return sendData;
    });

    api.__createBearerApi(["addMsgTemp", "UMH-添加消息事件模板"], "/v2/umh/admin/msg/template/add" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["lang_flag", "lang_name", "msg_format", "title"],
            numKey : ["mode"],
        });
        return sendData;
    });

    api.__createBearerApi(["editMsgTemp", "UMH-设置消息事件模板"], "/v2/umh/admin/msg/template/set" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["lang_flag", "lang_name", "msg_format", "title"],
            numKey : ["id", "mode"],
        });
        return sendData;
    });
    api.__createBearerApi(["delMsgTemp", "UMH-删除消息事件模板"], "/v2/umh/admin/msg/template/del" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : [],
            numKey : ["id"],
        });
        return sendData;
    });

    api.__createBearerApi(["getMsgTemp", "UMH-查询消息事件模板"], "/v2/umh/admin/msg/template/list" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : [],
            numKey : ["page_no", "page_size"],
        });
        return sendData;
    });
    api.__createBearerApi(["getUserDetail", "UMH-查询用户详细信息"], "/v2/umh/srv/user" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["user_id"],
            numKey : ["sync"],
        });
        return sendData;
    });
    api.__createBearerApi(["getAlarmLog", "UMH-后台查询报警记录"], "/v2/umh/admin/alarmlog/list" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["user_id","uid"],
            numKey : ["push_type","page_no","page_size"],
        });
        return sendData;
    });
    api.__createBearerApi(["getAlarmPush", "UMH-后台查询报警推送"], "/v2/umh/admin/alarmpush/list" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["link_id","uid","token"],
            numKey : ["push_type","send_state","page_no","page_size"],
        });
        return sendData;
    });
    api.__createBearerApi(["setUserTags", "UMH-设置用户标签"], "/v2/umh/admin/usertag/set" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["user_id","user_nid"],
            numKey : ["vip","white","log","ad", "iap"],
        });
        return sendData;
    });
    // 
    api.__createBearerApi(["setUserTagsXls", "UMH-添加用户 TAG导入文件"], "/v2/umh/admin/import/add" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["link_id"],
            numKey : ["link_type","type"],
        });
        return sendData;
    });
    api.__createBearerApi(["getUserTagsXls", "UMH-导入用户 TAG导入文件"], "/v2/umh/admin/import/list" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : [],
            numKey : ["state", "page_size","page_no"],
        });
        return sendData;
    });
    api.__createBearerApi(["getLicAuth", "UMH-查询Uid 授权"], "/v2/umh/admin/licauth/list" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : [],
            numKey : ["gmt_start", "gmt_end", "page_size","page_no"],
        });
        return sendData;
    });
    api.__createBearerApi(["addLicAuth", "UMH-添加 Uid 授权"], "/v2/umh/admin/licauth/add" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["sys", "file_url", "batch_id", "comp_path"],
            numKey : ["auth_type"],
        });
        return sendData;
    });
    api.__createBearerApi(["getLicAuthDetail", "UMH-获取Uid 授权"], "/v2/umh/admin/licauth/get" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["id", "uid", "sn"],
            numKey : ["auth_state", "page_no", "page_size"],
        });
        return sendData;
    });
    api.__createBearerApi(["setLicAuth", "UMH-设置Lic授权"], "/v2/umh/admin/licauth/set" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["id", "state_msg"],
            numKey : ["state"],
        });
        return sendData;
    });
    api.__createBearerApi(["getUserAna", "UMH-用户注册数据分析"], "/v2/umh/admin/useranalysis/list" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : [],
            numKey : ["app_master_id", "gmt_start", "gmt_end"],
        });
        return sendData;
    });
    api.__createBearerApi(["setUserLock", "UMH-设置用户信息-锁"], "/v2/umh/admin/user/set" ,function(data){
        let sendData = dataToSendData(data, {
            strKey : ["id"],
            numKey : ["lock_state"],
        });
        return sendData;
    });

    // 
}